import EventBus from './Event/index.js';

class GR_Memberstack {
  constructor() {
    if (!window.$memberstackDom) {
      console.error('Memberstack is not loaded');
      return;
    }

    this.initUser();
    this.initApp();
  }

  async initUser() {
    // try to get user
    try {
      const { data: currentMemberData } = await window.$memberstackDom.getCurrentMember();
      window.grapp.user = currentMemberData ? { ...currentMemberData } : null;
      EventBus.emit('user:loaded', window.grapp.user);
      console.log('user: ', window.grapp.user);
    } catch(err) {
      window.grapp.user = null;
      EventBus.emit('user:empty', window.grapp.user);
      console.log('ms user error: ', err);
      return;
    }

    // if a user is found (is logged in), get JSON data
    if (window.grapp.user) {
      try {
        const { data: jsonData } = await window.$memberstackDom.getMemberJSON();
        window.grapp.user.json = jsonData;
        EventBus.emit('user:json', window.grapp.user.json);
      } catch(err) {
        console.log('ms user JSON error: ', err);
      }
    }
  }

  async initApp() {
    const { data: msApp } = await window.$memberstackDom.getApp();

    window.grapp.msApp = { ...msApp };
    EventBus.emit('app:init', window.grapp.msApp);
    console.log('app: ', window.grapp.msApp);
  }

  static init() {
    return new GR_Memberstack();
  }
}

GR_Memberstack.init();
